const apiPaths = {
  getCancelFlow: '/locations/questionnaires?locationName=cancel-flow',
  getQuestionnaireAnswers: '/answers/users/self/questionnaires',
  getShoppingCredit: '/api/1/credits/campaigns/default',
  getDynamicText: '/preference/self/text',
  postQuestionnaireAnswers: '/answers',
  postCancelSubscription: '/answers/actions/cancelSubscription',
  postSkipBox: '/answers/actions/skipBox',
  putReactivateSubscription: '/answers/actions/reactivateSubscription',
  getCustomizeCampaignData: '/customize/self/campaign-state',
  getBoxState: '/boxes/self/box-state',
  getAccountInfo: '/users/self/accounts',
  getCancelCreditEligible: '/api/1/cancel-credit/is-eligible',
  postCancelCredit: '/api/1/cancel-credit',
  getSubscribableProducts: '/api/1/products/refillable/self',
  getProductsSelfData: '/products/self',
  postGwbExpirySwitchCadence: '/subscription-flags/self/gwb-expiry-switch-cadence',
  getSanityList: '/public/cms/sanity/list',
};

export { apiPaths };
